import { cva, type VariantProps } from "class-variance-authority";
import { useMemo } from "react";
import type { ExecutionOutput } from "@/client";
import { containsLatex, renderLatexToHtml } from "@/lib/latex";
import { cn } from "@/lib/utils";

const figureVariants = cva("object-contain", {
  variants: {
    size: {
      default: "max-h-96",
      large: "h-[600px] max-h-full",
    },
  },
  defaultVariants: {
    size: "default",
  },
});

export function Figure({
  url,
  long_name,
  size,
}: ExecutionOutput & VariantProps<typeof figureVariants>) {
  const hasLatex = long_name ? containsLatex(long_name) : false;
  const captionHtml = useMemo(
    () => (hasLatex ? renderLatexToHtml(long_name) : null),
    [long_name, hasLatex],
  );

  return (
    <div className="flex flex-col items-center gap-2">
      <img src={url} alt={long_name} className={cn(figureVariants({ size }))} />
      {captionHtml ? (
        <small
          className="text-muted-foreground line-clamp-3"
          // biome-ignore lint/security/noDangerouslySetInnerHtml: HTML is generated by KaTeX renderToString from trusted backend data, not user input
          dangerouslySetInnerHTML={{ __html: captionHtml }}
        />
      ) : (
        <small className="text-muted-foreground line-clamp-3">
          {long_name}
        </small>
      )}
    </div>
  );
}
